/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_History_Headline_Document_UploadedInputs */

const en_case_history_headline_document_uploaded = /** @type {(inputs: Case_History_Headline_Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent a file`)
};

const pt_br2_case_history_headline_document_uploaded = /** @type {(inputs: Case_History_Headline_Document_UploadedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviou um arquivo`)
};

/**
* | output |
* | --- |
* | "Sent a file" |
*
* @param {Case_History_Headline_Document_UploadedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_history_headline_document_uploaded = /** @type {((inputs?: Case_History_Headline_Document_UploadedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_History_Headline_Document_UploadedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_history_headline_document_uploaded(inputs)
	return pt_br2_case_history_headline_document_uploaded(inputs)
});